<script setup lang="ts"></script>

<template>
  <icon name="lucide:list-checks" />
</template>

<style scoped></style>
